import {Component, Input, OnInit} from '@angular/core';
import {PortfolioItemModel} from '../../assets/data/portfolio-item.model';
import {MatDialog} from '@angular/material/dialog';
import {CaseDialogComponent} from '../case-dialog/case-dialog.component';

@Component({
  selector: 'app-preview-item',
  templateUrl: './preview-item.component.html',
  styleUrls: ['./preview-item.component.scss']
})
export class PreviewItemComponent implements OnInit {
  hovered: boolean;
  @Input() item: PortfolioItemModel;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openDialog(item: PortfolioItemModel): void {
    const dialogRef = this.dialog.open(CaseDialogComponent, {
      panelClass: 'custom-dialog-container',
      data: item,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(1);
    });
  }

}
